module.exports = __webpack_public_path__ + "img/1-5.b3d97a86.svg";